export const dropinComponents = [
    {
      name: 'Order Details',
      id: 'order-details'
    },
    {
      name: 'Card',
      id: 'card'
    },
    {
      name: 'UPI',
      id: 'upi'
    },
    // {
    //   name: 'Wallets',
    //   id: 'app'
    // },
    {
      name: 'Netbanking',
      id: 'netbanking'
    },
    // {
    //   name: 'Paylater',
    //   id: 'paylater'
    // },
    // {
    //   name: 'Credit Card EMI',
    //   id: 'creditcardemi'
    // },
    // {
    //   name: 'Cardless EMI',
    //   id: 'cardlessemi'
    // }
  ];
  